export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_REQUIREMENTS = [
  {
    id: "length",
    label: `At least ${PASSWORD_MIN_LENGTH} characters`,
    test: (password) => (password || "").length >= PASSWORD_MIN_LENGTH,
  },
  {
    id: "lower",
    label: "One lowercase letter (a–z)",
    test: (password) => /[a-z]/.test(password || ""),
  },
  {
    id: "upper",
    label: "One uppercase letter (A–Z)",
    test: (password) => /[A-Z]/.test(password || ""),
  },
  {
    id: "digit",
    label: "One number (0–9)",
    test: (password) => /\d/.test(password || ""),
  },
  {
    id: "special",
    label: "One special character (!@#$…)",
    test: (password) => /[^A-Za-z0-9]/.test(password || ""),
  },
];

export function getPasswordRequirementStates(password) {
  return PASSWORD_REQUIREMENTS.map((rule) => ({
    ...rule,
    met: rule.test(password),
  }));
}

export function allPasswordRequirementsMet(password) {
  return getPasswordRequirementStates(password).every((rule) => rule.met);
}

export function getPasswordStrengthScore(password) {
  return getPasswordRequirementStates(password).filter((rule) => rule.met).length;
}

/** Four-segment strength meter (matches original login UI). */
export function getPasswordStrengthBarCount(password) {
  let score = 0;
  if ((password || "").length >= PASSWORD_MIN_LENGTH) score += 1;
  if (/[a-z]/.test(password || "") && /[A-Z]/.test(password || "")) score += 1;
  if (/\d/.test(password || "")) score += 1;
  if (/[^A-Za-z0-9]/.test(password || "")) score += 1;
  return score;
}

/** Registration / account-create password validation. */
export function validatePasswordForRegistration(password) {
  if (!password) return "Password is required.";
  if (allPasswordRequirementsMet(password)) return "";
  const unmet = getPasswordRequirementStates(password).filter((rule) => !rule.met);
  if (unmet.length === 1) {
    return `Password must include: ${unmet[0].label.charAt(0).toLowerCase()}${unmet[0].label.slice(1)}.`;
  }
  return "Password does not meet all requirements below.";
}
